import * as cn from "./Footer.scss"
import {User} from "./../model/User"
import {yearColumns} from "./Final"
import * as React from "react";
type Props = {
    user: User
}


export class Footer extends React.PureComponent<Props> {
    render() {
        const {user} = this.props

        return (
            <div className = {cn.page}>
                <table className = {cn.table} cellPadding = {0} cellSpacing = {0}>
                    <colgroup>
                        {Array.apply(null, Array(19)).map((value, key) => <col {...{key}} className = {cn.column}/>)}
                    </colgroup>
                    <tfoot>
                    <tr className = {cn.footRow}/>

                    {[
                        <tr key = {0} className = {cn.footRow}>
                            <td className = {cn.footCell} colSpan = {6} rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.chief.position}</td>
                            <td className = {cn.footCell}/>
                            <td className = {cn.footCell} colSpan = {10} rowSpan = {3}>{user.chief.fullName}</td>
                            <td className = {cn.footCell} colSpan = {2} rowSpan = {3}/>
                        </tr>,
                        <tr key = {1} className = {cn.footRow}/>,
                        <tr key = {2} className = {cn.footRow}/>,
                        <tr key = {3} className = {cn.footRow}/>,
                        <tr key = {4} className = {cn.footRow}>
                            <td className = {cn.footCell} colSpan = {7}/>
                            <td colSpan = {10} className = {cn.sign}>(Подпись)</td>
                            <td className = {cn.footCell} colSpan = {2}/>
                        </tr>,
                        <tr key = {5} className = {cn.footRow}/>,
                    ]}

                    <tr className = {cn.footRow}>
                        <td className = {cn.footCell} colSpan = {6}  rowSpan = {3} style={{verticalAlign: 'bottom'}}>{user.executor.position}</td>
                        <td className = {cn.footCell}/>
                        <td className = {cn.footCell} colSpan = {10} rowSpan = {3}>{user.executor.fullName}</td>
                        <td className = {cn.footCell} colSpan = {2}  rowSpan = {3}/>
                    </tr>
                    <tr className = {cn.footRow}/>
                    <tr className = {cn.footRow}/>
                    <tr className = {cn.footRow}/>
                    <tr key = {4} className = {cn.footRow}>
                        <td className = {cn.footCell} colSpan = {7}/>
                        <td colSpan = {10} className = {cn.sign}>(Подпись)</td>
                        <td className = {cn.footCell} colSpan = {2}/>
                    </tr>
{/*
                    <tr className = {cn.footRow}><td className = {cn.executor}>Ответственный:</td><td className = {cn.footCell} colSpan = {18}>{user.executor.fullName}</td></tr>
*/}
                    <tr className = {cn.footRow}>
                        <td/>
                        <td className = {cn.footCell} colSpan = {18}>{(user.executor.contacts !== undefined) ? user.executor.contacts.first() : ""}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        )
    }
}